import React from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import { Button, Dialog, Toast, Typography } from '@chilecompra/react-kit/components'
import { onCloseSustainabilityDirectDealStepTwo } from '../DirectDealStepTwo.actions'
import { onShowSnackbar } from '../../SnackBarProvider/SnackBarProvider.actions'

import { FILE_SUSTAINABILITY_DICTIONARY } from '../../../config/settings/constants'

import { GridContainer, GridItem, IconArrowDownward, Tab, Tabs } from '../DirectDealStepTwo.styles'

/**
 * The DirectDealStepTwo's sustainability dialog.
 */
const DirectDealStepTwoSustainabilityDialog = props => {
  const { open } = props

  const dispatch = useDispatch()

  const handleCloseDialog = () => {
    dispatch(onCloseSustainabilityDirectDealStepTwo())
  }

  const handleDownloadInfo = () => {
    const link = document.createElement('a')

    link.style.display = 'none'
    link.href = FILE_SUSTAINABILITY_DICTIONARY.URL_FILE
    link.download = FILE_SUSTAINABILITY_DICTIONARY.NAME_FILE

    document.body.appendChild(link)
    link.click()
    link.remove()

    dispatch(
      onShowSnackbar({
        title: 'Descarga realizada con éxito',
        severity: 'success'
      })
    )
  }

  return (
    <Dialog
      disableBackdropClick
      maxWidth="700px"
      padding="16px"
      open={open}
      onClose={handleCloseDialog}
      verticalAlign="top"
    >
      <GridContainer>
        <GridItem xs={12}>
          <Typography variant="h4" fontWeight="bold">
            ¿Qué es una compra pública sustentable?
          </Typography>
        </GridItem>
        <GridItem xs={12}>
          <Typography variant="body2">
            Es aquella que equilibra aspectos sociales, económicos y ambientales para generar mayor valor en todo el
            ciclo de vida del bien o servicio, reduciendo el impacto ecológico y generando beneficios sociales.
          </Typography>
        </GridItem>
        <GridItem xs={12}>
          <Toast severity="info">
            La sustentabilidad se puede incorporar como requisito obligatorio o criterio de evaluación, según el
            análisis del caso, procurando no limitar injustamente la participación de proveedores.
          </Toast>
        </GridItem>
        <GridItem xs={12}>
          <GridContainer flexDirection="column">
            <Tabs padding="16px 0 0" value="environmental" variant="fullWidth">
              <Tab
                id="environmental"
                label={
                  <Typography variant="body2" fontWeight="bold" color="primary">
                    Medioambientales
                  </Typography>
                }
              >
                <Typography fontWeight="bold" margin="0 0 16px" variant="h4">
                  ¿Qué son los criterios de evaluación o requisitos medioambientales?
                </Typography>

                <Typography margin="0 0 16px" variant="body2">
                  Buscan reducir el impacto ambiental de las compras públicas, considerando eficiencia energética,
                  materiales sustentables, vida útil y disposición final del producto o servicio.
                </Typography>

                <Typography margin="0 0 16px" variant="body2">
                  Ejemplos: reciclaje de desechos (papel, vidrio, electrónicos), eficiencia energética (LED, A+, Energy
                  Star), reducción de emisiones contaminantes, uso de materiales certificados (FSC, PEFC, reciclados) y
                  menaje reutilizable en catering.
                </Typography>

                <Typography margin="0 0 16px" variant="body2">
                  Se validan mediante sellos, certificaciones (Energy Star, HuellaChile, FSC, etc.), fichas técnicas,
                  declaraciones juradas o sitios oficiales.
                </Typography>
              </Tab>

              <Tab
                id="social-economic"
                label={
                  <Typography variant="body2" fontWeight="bold" color="primary">
                    Sociales o económicos
                  </Typography>
                }
              >
                <Typography fontWeight="bold" margin="0 0 16px" variant="h4">
                  ¿Qué son los criterios de evaluación o requisitos sociales o económicos?
                </Typography>

                <Typography margin="0 0 16px" variant="body2">
                  Promueven el desarrollo local, el empleo digno y la equidad en las compras públicas.
                </Typography>

                <Typography margin="0 0 16px" variant="body2">
                  Ejemplos: buenas condiciones laborales, inclusión de personas con discapacidad o jóvenes, equidad de
                  género (Sello Empresa Mujer), apoyo a pymes y cooperativas (Sello ProPyme), y fomento al mercado
                  local.
                </Typography>

                <Typography margin="0 0 16px" variant="body2">
                  Se validan mediante certificaciones, sellos (Empresa Mujer, ProPyme, APL, etc.), declaraciones, fichas
                  técnicas o contratos laborales.
                </Typography>
              </Tab>
            </Tabs>
          </GridContainer>
        </GridItem>
        <GridItem xs={12}>
          <GridContainer
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            direction={{ xs: 'column', sm: 'row' }}
          >
            <GridItem>
              <Button color="primary" variant="text" onClick={handleDownloadInfo}>
                <Typography variant="body2" fontWeight="bold" color="primary">
                  Descargar instructivo <IconArrowDownward margin="0 0 -7px 5px" fontSize="24px" />
                </Typography>
              </Button>
            </GridItem>
            <GridItem>
              <Button onClick={handleCloseDialog}>Cerrar</Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </Dialog>
  )
}

DirectDealStepTwoSustainabilityDialog.propTypes = {
  open: PropTypes.bool.isRequired
}

export default DirectDealStepTwoSustainabilityDialog
